import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitizes error messages to remove technical references like "n8n"
 * and replace them with user-friendly terms
 */
export function sanitizeErrorMessage(message: string | undefined | null): string {
  if (!message) return 'An error occurred. Please contact support if the issue persists.';
  
  let sanitized = String(message);
  
  // Replace n8n references (case-insensitive)
  sanitized = sanitized.replace(/n8n/gi, 'service');
  sanitized = sanitized.replace(/webhook/gi, 'service');
  
  // Replace technical error patterns
  sanitized = sanitized.replace(/Failed to connect to service/gi, 'Failed to connect to the service. Please contact support if the issue persists.');
  sanitized = sanitized.replace(/Invalid response from service/gi, 'Invalid response from the service. Please contact support if the issue persists.');
  sanitized = sanitized.replace(/Network error.*service/gi, 'Network error. Please contact support if the issue persists.');
  
  return sanitized.trim();
}
